import { useSearchParams } from 'react-router-dom';
import { ERROR_MESSAGES } from '../constants/appConfig';
import type { TokenErrorCode } from '../types/api.types';
import '../assets/styles/ErrorPage.css';

export default function ErrorPage() {
  const [searchParams] = useSearchParams();
  const reason  = (searchParams.get('reason') ?? 'UNKNOWN_ERROR') as TokenErrorCode;
  const message = ERROR_MESSAGES[reason] ?? ERROR_MESSAGES['UNKNOWN_ERROR'];

  return (
    <div className="ep-center-group">
      <div className="ep-message-block">
        <p className="ep-error-text">{message}</p>
        <p className="ep-error-ref">
          Reference code:{' '}
          <span aria-label={`Error code: ${reason}`}>{reason}</span>
        </p>
        <p className="ep-contact-text">If you continue to experience issues, please contact your HR department for assistance.</p>
      </div>
    </div>
  );
}
